<div class="dashboard_wrapper">
  <div class="glow green"></div>
  <div class="glow purple"></div>
  <div class="dashboard">
    <app-daily-rewards></app-daily-rewards>
    <app-featured-games></app-featured-games>
    <app-points-shop></app-points-shop>
  </div>
</div>

